// Imported for its side effect, first in each root layout: imports run in order,
// so error reporting starts before the layout's other imports load. Errors thrown
// while those load are then reported. Its own imports (the build config) still
// load first.
import { startErrorReporting } from "./error-reporting";

startErrorReporting();
